import { Button, Grid } from "@mui/material";
import { useFormikContext } from "formik";
import { useLocales } from "../../hooks";
import { changeFileName, checkFileSize, isExists } from "../../utils";
import Swal from "sweetalert2";
import { FileUploadInput, TextInput } from "../../components";

interface IProps {
  open: boolean;
  setOpen: Function;
  setDocument: Function;
}

const ModalDocument = ({ open, setOpen, setDocument }: IProps) => {
  const formik: any = useFormikContext();
  const { translate } = useLocales();
  const handleClose = () => {
    setOpen(false);
    setDocument(false);
    formik.setFieldValue(`file.base64`, "", false);
    formik.setFieldValue(`file.fileName`, "", false);
    formik.setFieldValue(`file.contentType`, "", false);
  };

  function alertHandler() {
    if (isExists(formik.values.file.fileName)) {
      Swal.fire(translate("resources.workOrders.file_updated"), "", "success");
    } else {
      Swal.fire(translate("resources.workOrders.file_uploaded"), "", "success");
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item md={12}>
        <FileUploadInput
          name="document"
          //accept="application/pdf"

          onChange={(event: any) => {
            const file = event.target.files[0];
            if (!checkFileSize(file)) {
              Swal.fire({
                icon: "error",
                title: "Değerli Müşterimiz,",
                text: translate("actions.invalidFileSize"),
              });
              return null;
            }

            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = (e: any) => {
              alertHandler();
              formik.setFieldValue(
                `file.base64`,
                e.target.result.split(",")[1] ?? "",
                false
              );

              const fileName = isExists(file.name)
                ? changeFileName(file.name)
                : "";

              formik.setFieldValue(`file.fileName`, fileName, false);
              formik.setFieldValue(`file.contentType`, file.type, false);
              event.target.value = null; /* */
            };
          }}
        />
      </Grid>
      <Grid item md={12}>
        <TextInput
          name={`file.fileName`}
          label={translate("resources.workOrders.file_name")}
          disabled
        />
      </Grid>

      <Grid item md={12}>
        <Button
          variant="outlined"
          color="error"
          onClick={handleClose}
          fullWidth
          style={{ height: "50px" }}
        >
          SİL
        </Button>
        <Grid item md={12}>
          <TextInput
            name="description"
            label={translate("resources.customers.documents.description")}
            rows={3}
            multiline
            style={{ marginTop: "10px" }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalDocument;
